import { useState } from "react";
import ParcelBoxResult from "./ParcelBoxResult.jsx";
import { Input, Button, Box, VStack, HStack, Text } from "@postenbring/hedwig-react";

import "./find-parcel-box.scss";

export const FindParcelBox = ({ title, label, buttonText, mapLabel, noResultMessage, lang }) => {
    const [postCode, setPostCode] = useState("");
    const [res, setRes] = useState();

    const handleChange = (postCode) => {
        setPostCode(postCode);
    };

    function handleKeyDown(e) {
        if (e.keyCode === 13) {
            //Enter key
            lookupParcelBox();
        }
    }

    function lookupParcelBox() {
        const query =
            "postalCode=" +
            encodeURIComponent(postCode) +
            "&count=5" +
            "&lang=" +
            encodeURIComponent(lang || "no");

        fetch(`./_/service/no.posten.website/pakkebox-search?${query}`)
            .then((results) => {
                return results.json();
            })
            .then((data) => {
                if (data.units.length > 0) {
                    setRes(data.units);
                } else if (data.units.length == 0) {
                    setRes([]);
                }
            })
            .catch(() => {});
    }

    return (
        <Box asChild>
            <VStack gap="20-24">
                <Text variant="h3">{title}</Text>
                <HStack gap="8" wrap>
                    <Input
                        label={label}
                        onChange={(postCode) => handleChange(postCode.target.value)}
                        maxLength={4}
                        type="text"
                        onKeyDown={(key) => handleKeyDown(key)}
                        value={postCode}
                    />
                    <Button
                        data-color="posten"
                        onClick={() => lookupParcelBox()}
                        aria-controls="searchResults"
                        className="kp-find-parcel-box-button"
                    >
                        {buttonText}
                    </Button>
                </HStack>
                {res && res.length > 0 && <ParcelBoxResult res={res} mapLabel={mapLabel} />}
                {!res && <div className="kp-parcel-box-result" aria-live="polite"></div>}
                {res && res.length === 0 && (
                    <div className="kp-parcel-box-result" aria-live="polite">
                        <p>{noResultMessage}</p>
                    </div>
                )}
            </VStack>
        </Box>
    );
};
